import React from "react";
// import PropTypes from 'prop-types'

const CommunicationMethod = React.forwardRef(
  function CommunicationMethod(props, ref) {
    const { methods, title, onChange, showTitles } = props
    const changeSelectedMethodHandler = (e) => {
      if (onChange) onChange(e);
    };
    return (
      <div className="form-label">
        <div className="communication-method">
          <span className="form-label__placeholder form-label__placeholder_top">
            {title}
          </span>
          {methods.map(({ value, title: methodTitle }, idx) => (
            <React.Fragment key={value}>
              <input
                defaultChecked={idx === 0}
                id={`commMeth_${value}`}
                name="communication_method"
                onChange={changeSelectedMethodHandler}
                type="radio"
                value={value}
                ref={ref}
              />
              <label
                className={`communication-method__item`}
                htmlFor={`commMeth_${value}`}
                title={methodTitle}
              >
                <span className={`com-met-icon com-met-icon_${value}`}></span>
                {showTitles && ' ' + methodTitle}
              </label>
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }
);

CommunicationMethod.defaultProps = {
  methods: [
    {
      value: "phone",
      title: "Phone",
    },
    {
      value: "viber",
      title: "Viber",
    },
    {
      value: "telegram",
      title: "Telegram",
    },
    {
      value: "messenger",
      title: "Messenger",
    },
    {
      value: "email",
      title: "Email",
    },
  ],
  defaultMethod: "phone",
  title: "",
};

// CommunicationMethod.propTypes = {}

export default CommunicationMethod;
